import common from '../common';

export default {
  jpath: ['spectra', 'elementalAnalysis'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
};
